import { LanguagesTypes } from '@hydra/types';

function getLanguage (locale: LanguagesTypes): string {
  switch (locale) {
    case 'es':
    case 'fr':
      return locale;
    default:
      return 'en';
  }
}

export default function getAboutLink (locale: LanguagesTypes): string {
  const language = getLanguage(locale);
  return `https://www.woorank.com/${language}/about`;
}
